import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/banner/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/banner/DomruBanner.tsx");
